import { TicketComplianceDetails } from './TicketComplianceDetails'

import './Tickets/Tickets.scss'

const TicketComplianceTabs = (): JSX.Element => <TicketComplianceDetails />

export default TicketComplianceTabs
